import Payment from "../components/Payment";
function PaymentPage() {
  return (
    <div className='w-full bg-secondary-tint'>
      <Payment />
    </div>
  );
}
export default PaymentPage;
